"use strict";

if (document.getElementById("app_edit_job")) {
  new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_edit_job',
    data: {
      id: '',
      job: [],
      url: ''
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
      this.id = this.$el.dataset.id;
      this.url = this.$el.dataset.url;

      if (this.id) {
        this.getJob();
      } else {
        CKEDITOR.replace('description', {
          customConfig: confCKeditorBlog
        });
      }
    },
    methods: {
      getJob: function getJob() {
        var _this = this;

        var urlApi = '/api/v1/jobs/' + this.id;
        $.ajax({
          url: urlApi,
          method: 'GET',
          headers: {
            'Accept-Language': languageCode
          },
          // beforeSend: request => request.setRequestHeader("Accept-Language", languageCode),
          success: function success(data) {
            console.log(data);
            _this.job = data;
            CKEDITOR.replace('description', {
              customConfig: confCKeditorBlog
            });
          },
          error: function error(_error) {
            console.log(_error);
          }
        });
      },
      save: function save() {
        var endpoint = this.id ? '/api/v1/jobs/' + this.id : '/api/v1/jobs';
        var method = this.id ? 'PUT' : 'POST';
        var dataToSend = {
          "title": $('#title').val(),
          "sector": $('#sector').val(),
          "city": $('#city').val(),
          "contract_type": $('#contract_type option:selected').val(),
          "salary": $('#salary').val(),
          "department": $('#department_name option:selected').val(),
          "is_published": $('#publish').prop('checked'),
          "content": CKEDITOR.instances['description'].getData(),
          "published_date": $('#date_published').val(),
          "lawyer": $('#author').val()
        };
        var existing_id = this.id;
        $.ajax({
          url: endpoint,
          type: method,
          data: JSON.stringify(dataToSend),
          cache: false,
          contentType: 'application/json',
          processData: false,
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(data) {
            new Alert().success();
            $('.js-notification').addClass('show');
            setTimeout(function () {
              $('.js-notification').removeClass('show');

              if (!existing_id) {
                window.location.replace($('.js-create-job').data('success'));
              }
            }, 1500);
          },
          error: function error(_error2) {
            var errors = _error2.responseJSON;
            new Alert().error();

            for (_error2 in errors) {
              $('[data-error="' + _error2 + '"]').addClass('has-error');
            }
          }
        });
      },
      deleteJob: function deleteJob() {
        var _this2 = this;

        $.ajax({
          url: '/api/v1/jobs/' + this.id,
          type: 'DELETE',
          success: function success(data) {
            console.log(data);
            window.location.href = _this2.url;
          },
          error: function error(_error3) {
            console.log(_error3);
          }
        });
      }
    }
  });
} // (function ( $ ) {
//     $.fn.updateJob = function() {
//         var that = $(this);
//         that.on('submit', function(e) {
//             e.preventDefault();
//             if($(this).hasClass('js-create-job')) {
//                 var urlApi = '/api/v1/jobs';
//                 var method = 'POST'
//             } else {
//                 var urlApi = '/api/v1/jobs/' + $('.js-job').data('id');
//                 var method = 'PUT';
//             }
//             var dataToSend = {
//                 "title" : $('#title').val(),
//                 "sector" : $('#sector').val(),
//                 "city" : $('#city').val(),
//                 "contract_type" : $('#contract_type option:selected').val(),
//                 "salary" : $('#salary').val(),
//                 "department" : $('#department_name option:selected').val(),
//                 "is_published" : $('#publish').prop('checked'),
//                 "content" : CKEDITOR.instances['description'].getData(),
//                 "published_date" : $('#date_published').val(),
//                 "lawyer" : $('#author').val()
//             };
//             $.ajax({
//                 url: urlApi,
//                 type: method,
//                 data: JSON.stringify(dataToSend),
//                 cache: false,
//                 contentType: 'application/json',
//                 processData: false,
//                 success: function(data) {
//                     new Alert().success();
//                     $('.js-notification').addClass('show');
//                     setTimeout(function() {
//                         $('.js-notification').removeClass('show');
//                         window.location.replace(that.data('success'));
//                     }, 1500);
//                 },
//                 error: function(error) {
//                     var errors = error.responseJSON;
//                     new Alert().error();
//                     for(error in errors) {
//                         $('[data-error="'+ error +'"]').addClass('has-error');
//                     }
//                 }
//             });
//         })
//     };
// }( jQuery ));
// $(function(){
//     if ($('.js-form-job').length) {
//         $('.js-form-job').updateJob();
//     }
// });